/**
 * Component displaying the history of the billing for the billing page.
 *
 * Author: Bounlith Sirivong <bounlith.sirivong@ircamamplify.com>
 * Copyright © Ircam Amplify 2025-2026
 */

import Button from '@/components/Button/Button'

import {
  formatInvoiceDate,
  InvoicePdfLink,
  InvoiceStatus,
  TextUtil,
} from '@amplify3/duplo-back-end'
import './billing.css'
import './BillingHistory.css'

interface BillingHistoryProps {
  className?: string
  invoicePdfList: InvoicePdfLink[] | undefined
  hasMoreInvoicePage: boolean
  lastInvoiceId: string
  getInvoices: any
}

const BillingHistory = (props: BillingHistoryProps) => {
  const fullClassName = `${props.className} billing-history`
  const buttonClassName = `
    cursor-pointer
    load-more-button
    ${!props.hasMoreInvoicePage ? 'disabled' : ''}`

  const Dot = ({ size, className }: { size: number; className?: string }) => {
    return (
      <div
        className={className}
        style={{
          width: size,
          height: size,
          borderRadius: '50%', // makes it a circle
          display: 'inline-block',
        }}
      />
    )
  }

  const InvoiceStatusComp = ({ status }: { status: InvoiceStatus }) => {
    const className = `invoice-status ${status}`
    const classNameDot = `invoice-status dot ${status}`
    return (
      <div className={className}>
        <Dot size={10} className={classNameDot} />
        {TextUtil.capitalizeWordFirstChar(status)}
      </div>
    )
  }

  return (
    <div className={fullClassName}>
      <div className="billing-history-header">
        <div className="billing-component-title">Billing History</div>
      </div>

      {undefined === props.invoicePdfList ||
      props.invoicePdfList.length == 0 ? (
        <div className="no-invoice-message">
          You don't have any invoice available for now.
        </div>
      ) : (
        <>
          <table className="billing-history-table">
            <tbody>
              {props.invoicePdfList?.map((invoice, index) => (
                <tr key={index}>
                  <td>{formatInvoiceDate(invoice.creationDate)}</td>
                  <td>
                    <InvoiceStatusComp status={invoice.status} />
                  </td>
                  <td>
                    <a href={invoice.pdfLink} download>
                      <div className="download-cell">
                        <img
                          src="/icon/download-file-65px.png"
                          alt="Download file"
                          width="16px"
                          height="16px"
                        />
                        Invoice
                      </div>
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <Button
            label="Load more"
            dark
            className={buttonClassName}
            onClick={() => props.getInvoices(props.lastInvoiceId)}
          />
        </>
      )}
    </div>
  )
}

export default BillingHistory
